"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get_documents_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const main_1 = require("../../../main");
const document_1 = require("../../document");
const get_documents_1 = require("../../../../../api/calls/document/get_documents");
exports.get_documents_thunk = (0, toolkit_1.createAsyncThunk)("documents/thunks/get_documents_thunk", (arg, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    let { data } = arg;
    dispatch((0, document_1.setDocumentsLoading)(true));
    data = data ? data : {};
    const response = yield (0, get_documents_1.get_documents)(Object.assign(Object.assign({}, data), { type: "DOCUMENT" }));
    dispatch((0, document_1.setDocumentsLoading)(false));
    if (response.success) {
        dispatch((0, document_1.setDocuments)(response.content.documents));
        dispatch((0, document_1.setDocumentsCount)(response.content.count || 0));
    }
    else {
        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
    }
}));
